import axios from 'axios'
import { BaseService } from '../base.service'
import logRequests from '@lib/utils/axiosUtils'
import { APP_VERSION } from '@shared/appVersion'

const apiBaseURL = import.meta.env.RENDERER_VITE_BACKEND_URL
export class BackendService extends BaseService {
  readonly client

  constructor(serviceName: string) {
    super()

    this.client = axios.create({
      baseURL: `${apiBaseURL}`,
      timeout: 10 * 1000 // 10s
    })

    logRequests(`backend/${serviceName}`, this.client)

    // added after logRequests so it runs first (axios runs request interceptors LIFO),
    // and the logged request reflects the headers actually sent.
    // app.store.ts is imported dynamically because it (transitively, via the other
    // backend services) imports this same file - a static import here would create
    // a circular dependency and break BackendService's class initialization.
    this.client.interceptors.request.use(async (config) => {
      const { useAppStore } = await import('@stores/app.store')
      const store = useAppStore()

      config.headers.set('x-front-version', APP_VERSION)

      const sessionId = store.cart?.sessionId
      const user = store.user

      config.headers.set('x-mcid', user?.mcId ?? 'anonymous')

      if (sessionId) {
        config.headers.set('x-session-id', sessionId)

        if (user) {
          config.headers.set('x-customer-verified', String(user.verified))
          if (store.isUserFullExp) config.headers.set('x-customer-id', user.imId)
        }
      }

      return config
    })
  }
}
